import { Component, Input, OnChanges } from '@angular/core';
import { AccountIconName } from './account-icon.component';
import { SUPPORT_EMAIL } from '../account-settings.static-data';

export type AccountSection = 'profile' | 'security';

interface SidebarItem {
  label: string;
  path: string;
  icon: AccountIconName;
  _uiSelected: boolean;
}

interface SectionMeta {
  title: string;
  items: Omit<SidebarItem, '_uiSelected'>[];
}

const SECTIONS: Record<AccountSection, SectionMeta> = {
  profile: {
    title: 'USER PROFILE',
    items: [
      { label: 'User Details', path: 'user-profile/details', icon: 'user' },
      { label: 'Access', path: 'user-profile/access', icon: 'grid' },
      { label: 'Terms', path: 'user-profile/terms', icon: 'file' },
    ],
  },
  security: {
    title: 'SECURITY',
    items: [
      { label: 'Authentication', path: 'security/authentication', icon: 'shield' },
      { label: 'Authorized devices', path: 'security/authorized-devices', icon: 'devices' },
    ],
  },
};

const OTHER_SECTION_CARD: Record<AccountSection, { title: string; hint: string; path: string; icon: AccountIconName }> = {
  profile: { title: 'Security', hint: 'Authentication, devices', path: 'security/authentication', icon: 'shield' },
  security: { title: 'User Profile', hint: 'Details, access, terms', path: 'user-profile/details', icon: 'user' },
};

@Component({
  selector: 'app-account-sidebar',
  templateUrl: './account-sidebar.component.html',
  styleUrls: ['./account-sidebar.component.scss'],
  standalone: false,
})
export class AccountSidebarComponent implements OnChanges {
  @Input() section: AccountSection = 'profile';
  /** Empty when no site is picked yet: links then point at the site-less /account pages. */
  @Input() siteId = '';
  @Input() currentUrl = '';

  title = '';
  items: SidebarItem[] = [];
  otherCard = OTHER_SECTION_CARD.profile;
  otherCardLink = '';
  readonly supportMailto = `mailto:${SUPPORT_EMAIL}`;

  ngOnChanges(): void {
    const meta = SECTIONS[this.section];
    const base = this.siteId ? `/paybev/${this.siteId}` : '/account';
    this.title = meta.title;
    this.items = meta.items.map((item) => ({
      ...item,
      path: `${base}/${item.path}`,
      _uiSelected: this.currentUrl.includes(`/${item.path}`),
    }));
    this.otherCard = OTHER_SECTION_CARD[this.section];
    this.otherCardLink = `${base}/${this.otherCard.path}`;
  }
}
